import {ProductVariant} from '@mintdata-wsp/common/controllers/network/generated/responses/ProductVariant';

export class ChargePeriod
{
    public static readonly Month:ChargePeriod = new ChargePeriod('month');
    public static readonly Annual:ChargePeriod = new ChargePeriod('annual');

    public static MONTHS_PER_YEAR:number = 12.00;

    private _value:string;

    constructor(value: string)
    {
        this._value = value;
    }

    // public static getPricePerMonth(productVariant:ProductVariant):number | null
    // {
    //     if( !productVariant )
    //         return null;
    //
    //     const pricePeriod = ChargePeriod.fromString(productVariant.pricePeriod);
    //
    //     if( ChargePeriod.Month.isEqualTo(pricePeriod) )
    //         return productVariant.price;
    //     else if( ChargePeriod.Annual.isEqualTo(pricePeriod) )
    //         return productVariant.price / ChargePeriod.MONTHS_PER_YEAR;
    //     else
    //         return null;
    // }

    public static formatPrice(price:any):string
    {
        const priceNumber:number = Number(price);
        const formattedPrice:string = priceNumber.toLocaleString('en-us',
                                                                 {minimumFractionDigits: 0,
                                                                     maximumFractionDigits: 0 });

        return formattedPrice;
    }

    public static fromString(stringValue:string):ChargePeriod | null
    {
        if( ChargePeriod.Month._value === stringValue )
            return ChargePeriod.Month;
        else if( ChargePeriod.Annual._value === stringValue )
            return ChargePeriod.Annual;
        else
            return null;
    }

    public static formatForDisplay(period:ChargePeriod):string
    {
        if( ChargePeriod.Month.isEqualTo(period) )
            return 'month';
        else if( ChargePeriod.Annual.isEqualTo(period) )
            return 'year';
        else
            return null;
    }

    isEqualTo(chargePeriod:ChargePeriod):boolean
    {
        return chargePeriod && chargePeriod._value === this._value;
    }

    isPricePeriodOf(productVariant:ProductVariant):boolean
    {
        return  productVariant &&
            productVariant.pricePeriod === this._value;
    }

    // TODO ???
    // isTrialPeriodOf(productVariant:ProductVariant):boolean
    // {
    //     return  productVariant &&
    //         productVariant.trialPeriod === this._value;
    // }
}
